import './App.css';
import ImageComponent from './components/ImageComponent';
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import {NextUIProvider} from "@nextui-org/react";

function App() {
  return (
    <NextUIProvider>
    <Router>
    <div className="App">
      <Routes>
          <Route path="/:number" element={<ImageComponent />} />
          <Route path="/" element={<ImageComponent />} />
      </Routes>
    </div>
    </Router>
    </NextUIProvider>
  );
}

export default App;
